import axios from "axios";

const Localserver = "http://localhost:5000/app/v1";
const remoteServer = "https://tle-server-cp2t.onrender.com/app/v1";

export default axios.create({
  baseURL: remoteServer,
});
